var scope_0 = require('/builds/ototadana/knowledge-swimmer-site-v1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/26ff58034b2bd0543fd544bc66bfacb7.js').default;
var scope_1 = require('/builds/ototadana/knowledge-swimmer-site-v1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/335e0fe71f120b9f2395b499932fc8bd.js').default;
var scope_2 = require('/builds/ototadana/knowledge-swimmer-site-v1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    